import { Ambulance, BedDouble, CarTaxiFront, Plane, ShoppingBag, Utensils } from "lucide-react";

export const situations = [
  {
    id: "airport",
    title: "Aeropuerto",
    subtitle: "Check-in, migraciones y equipaje",
    icon: Plane,
    phrases: ["¿Dónde está la puerta de embarque?", "Mi equipaje no apareció.", "Estoy en tránsito hacia otro país."],
  },
  {
    id: "taxi",
    title: "Taxi y transporte",
    subtitle: "Llegá sin confusiones",
    icon: CarTaxiFront,
    phrases: ["¿Cuánto cuesta el viaje hasta el hotel?", "Por favor, llevame a esta dirección.", "¿Podés dejarme en la entrada principal?"],
  },
  {
    id: "hotel",
    title: "Hotel",
    subtitle: "Check-in, habitaciones y ayuda",
    icon: BedDouble,
    phrases: ["Tengo una reserva a mi nombre.", "¿A qué hora es el desayuno?", "Necesito ayuda con la habitación."],
  },
  {
    id: "restaurant",
    title: "Restaurante",
    subtitle: "Menú, alergias y cuenta",
    icon: Utensils,
    phrases: ["¿Este plato contiene frutos secos?", "Quisiera pedir esta opción, por favor.", "¿Podés traerme la cuenta?"],
  },
  {
    id: "shopping",
    title: "Compras",
    subtitle: "Precios, talles y devoluciones",
    icon: ShoppingBag,
    phrases: ["¿Cuál es el precio final?", "¿Tenés este producto en otro tamaño?", "¿Puedo cambiarlo si no me sirve?"],
  },
  {
    id: "emergency",
    title: "Emergencias",
    subtitle: "Pedí ayuda con claridad",
    icon: Ambulance,
    phrases: ["Necesito asistencia médica.", "Por favor, llamá a emergencias.", "Soy alérgico a este medicamento."],
  },
] as const;
